import { render, staticRenderFns } from "./MongoDataTableItemField.vue?vue&type=template&id=b6fa6b3a&"
import script from "./MongoDataTableItemField.vue?vue&type=script&lang=js&"
export * from "./MongoDataTableItemField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports